import { render, staticRenderFns } from "./Modal2FA.vue?vue&type=template&id=9564fb40&scoped=true"
import script from "./Modal2FA.vue?vue&type=script&lang=js"
export * from "./Modal2FA.vue?vue&type=script&lang=js"
import style0 from "./Modal2FA.vue?vue&type=style&index=0&id=9564fb40&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9564fb40",
  null
  
)

export default component.exports